import clsx from "clsx";

import formClasses from "../styles.module.scss";

import type { ITextareaProps } from "./types";
import classes from "./styles.module.scss";

import { useReadOnly } from "@/hooks";
import { p2e } from "@/utils";

export function Textarea(props: ITextareaProps) {
  const {
    className,
    onChangeValue,
    rows = 5,
    validation,
    readOnly: propsReadOnly,
    disabled,
    value,
    ...rest
  } = props;
  const readOnly = useReadOnly(propsReadOnly);

  return (
    <textarea
      className={clsx([
        formClasses["form-control"],
        classes.textarea,
        className,
      ])}
      onChange={(event) => onChangeValue?.(p2e(event.target.value.trimStart()))}
      value={value}
      rows={rows}
      readOnly={readOnly}
      disabled={disabled}
      data-validation={validation}
      {...rest}
    />
  );
}
